import { get as networkGet } from '../../networkClient';
import { Path } from '../path';

export async function getCoreKnowledge(clientId, communityId) {
  try {
    const params = { client_id: clientId };
    if (communityId) {
      params.community_id = communityId;
    }
    const response = await networkGet(
      Path.GET_CORE_KNOWLEDGE,
      params,
      null,
      true,
      true
    );

    return response?.data;
  } catch (error) {
    return {
      error: true,
      message: error.message,
      status: error.response?.status
    };
  }
}
